/* Small stroke icons for the Match Controls buttons (MatchDetail). <McIcon name="pause" /> */
import React from 'react';

const P = {
  warmup: <><circle cx="12" cy="13" r="8" /><path d="M12 9v4l2 2" /><path d="M9 2h6" /></>,
  knife: <><path d="M3 21l7-7" /><path d="M10 14l9.5-9.5a2.1 2.1 0 0 1 3 3L13 17z" /></>,
  live: <><polygon points="6 4 20 12 6 20 6 4" /></>,
  pause: <><rect x="6" y="4" width="4" height="16" rx="1" /><rect x="14" y="4" width="4" height="16" rx="1" /></>,
  prod: <><rect x="2" y="7" width="15" height="12" rx="2" /><path d="M17 11l5-3v10l-5-3" /></>,
  unpause: <><polygon points="6 4 20 12 6 20 6 4" /><path d="M2 4v16" /></>,
  migrate: <><path d="M17 3l4 4-4 4" /><path d="M3 7h18" /><path d="M7 21l-4-4 4-4" /><path d="M21 17H3" /></>,
  rehost: <><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8" /><path d="M21 3v5h-5" /></>,
  restore: <><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5" /><path d="M12 7v5l3 2" /></>,
  forfeit: <><path d="M4 22V4" /><path d="M4 4h12l-2 4 2 4H4" /></>,
  cancel: <><circle cx="12" cy="12" r="9" /><path d="M15 9l-6 6M9 9l6 6" /></>,
  teams: <><circle cx="9" cy="8" r="3.5" /><path d="M2 20a7 7 0 0 1 14 0" /><path d="M16 4a3.5 3.5 0 0 1 0 7" /><path d="M18 14a7 7 0 0 1 4 6" /></>,
  swap: <><path d="M7 4L3 8l4 4" /><path d="M3 8h14a4 4 0 0 1 4 4" /><path d="M17 20l4-4-4-4" /><path d="M21 16H7a4 4 0 0 1-4-4" /></>,
  reset: <><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /></>,
  replay: <><path d="M3 12a9 9 0 1 0 3-6.7L3 8" /><path d="M3 3v5h5" /><polygon points="10 9 15 12 10 15 10 9" /></>,
  undo: <><path d="M9 14L4 9l5-5" /><path d="M4 9h11a5 5 0 0 1 0 10h-4" /></>,
};

export default function McIcon({ name, size = 13 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="mc-ico">
      {P[name]}
    </svg>
  );
}
